
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { LinkCollection, LinksApiUiClient } from '../backend/backendapi';
import { initClient } from '../../api';
import CenterOnParent from '../util/CenterOnParent';

@Component({
  components: { CenterOnParent },
})
export default class Show extends Vue {
  @Prop({ required: true })
  collectionId!: string;

  private readonly api = initClient(LinksApiUiClient);
  collection: LinkCollection | null = null;
  breadCrumbColor: string | null = null;
  buttonColor: string | null = null;
  backgroundSize: string | null = 'cover';

  async mounted(): Promise<void> {
    this.collection = await this.api.getById(this.collectionId);
    // we use searchparam lib it expects '&' instead of whitespace
    const searchParams = new URLSearchParams(this.collection.customCss.replace(/\s/g, '&'));
    if (searchParams.has("breadCrumbColor") === true) {
      this.breadCrumbColor = searchParams.get("breadCrumbColor");
    }
    if (searchParams.has("buttonColor") === true) {
      this.buttonColor = searchParams.get("buttonColor");
    }
    if (searchParams.has("backgroundsize") === true) {
      this.backgroundSize = searchParams.get("backgroundsize");
    }
    if (this.collection.backgroundImage.includes('data:image')) // check for background image data      {
    {
      // we need a top element outside of the template so we need pure javascript
      // https://developer.mozilla.org/en-US/docs/Web/CSS/background-size
      var elem = document.getElementById('page-top');
      if (elem === null) throw "page-top backgrond id not here";
      let base64 = "url(" + this.collection.backgroundImage + ")";
      if( this.backgroundSize=='auto' || this.backgroundSize=='contain')
      {
        elem.setAttribute("style", "background-image:" + base64 + "; background-repeat:repeat; background-position: center center; background-size: " + this.backgroundSize + ";");
      }
      else
      {
        elem.setAttribute("style", "background-image:" + base64 + "; background-repeat:no-repeat; background-size: " + this.backgroundSize + ";");
      }
    }
  }

  //this is in no way secure, see https://cheatsheetseries.owasp.org/cheatsheets/XSS_Filter_Evasion_Cheat_Sheet.html
  //danny meant this is fine, this is gonna fall on our heads at some point
  detectDangerousTags(html: string): string {
    if (html.includes('<script') || html.includes('<img') || html.includes('onerror'))
      return 'error';
    return html;
  }
}
